// "2 h ago", "yesterday", "last week": relative time in the UI language, via Intl so
// Hebrew comes out right with no hand-written plurals. `now` is a parameter for tests.
const MINUTE = 60;
const HOUR = 3600;
const DAY = 86_400;

export function relativeTime(iso: string, now: Date, locale: string): string {
  const seconds = Math.round((Date.parse(iso) - now.getTime()) / 1000);
  const past = Math.abs(seconds);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto", style: "short" });

  if (past < MINUTE) return rtf.format(0, "second");
  if (past < HOUR) return rtf.format(Math.round(seconds / MINUTE), "minute");
  if (past < DAY) return rtf.format(Math.round(seconds / HOUR), "hour");
  if (past < 7 * DAY) return rtf.format(Math.round(seconds / DAY), "day");
  if (past < 28 * DAY) return rtf.format(Math.round(seconds / (7 * DAY)), "week");
  return new Intl.DateTimeFormat(locale, { day: "numeric", month: "short", year: "numeric" }).format(new Date(iso));
}
